<template>
    <div class="widget-calendar">
        <dashboardCard heading='Gc Pause Detail' :data1="gcPauseCount" :data2="gcPauseTotal" :data3="gcPauseMax">
        </dashboardCard>
    </div>
</template>
<script>
import dashboardCard from "./DashboardCard.vue";
export default {
    name: "GcPauseDetail",
    components: {
        dashboardCard
    },
    data() {
        return {
            gcPauseCount: {},
            gcPauseTotal: {},
            gcPauseMax: {},
        };
    },
    methods: {
        getGcPause(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    this.gcPauseCount.value = response.server.data[0].value >= 1000
                        ? (response.server.data[0].value / 1000).toFixed(3) + 'K'
                        : response.server.data[0].value;
                    this.gcPauseCount.name = 'Count'
                    this.gcPauseTotal.value = this.formatTime((response.server.data[1].value).toFixed(2));
                    this.gcPauseTotal.name = 'Total Time'
                    this.gcPauseMax.value = this.formatTime((response.server.data[2].value).toFixed(2));
                    this.gcPauseMax.name = 'Max';
                    this.gcPauseCount.description = 'Represents total number of garbage collection pause events recorded.'
                    this.gcPauseTotal.description = 'Represents cumulative duration of all GC pause events.'
                    this.gcPauseMax.description = 'Represents the longest single GC pause duration.'
                })
                .catch(error => {
                    console.log(error);
                });
        },
        formatTime(seconds) {
            if (seconds < 60) {
                return `${seconds}s`;
            } else if (seconds < 3600) {
                const minutes = Math.floor(seconds / 60);
                return `${minutes}m`;
            } else {
                const hours = Math.floor(seconds / 3600);
                const minutes = Math.floor((seconds % 3600) / 60);
                const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
                return `${hours}h ${formattedMinutes}m`;
            }
        },
    },
    mounted() {
        this.getGcPause("GC_PAUSE");
    }
};
</script>